// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5796870d","553":"762122e2","977":"437eedd9"}[chunkId] + ".chunk.js";
};